<template>
  <v-container style="width: 95%; padding-top: 4%;">
  <v-container
    style="width: 100%;"
    v-for="element in content"
    class="text-left"
  >
    <v-row class="mb-10" no-gutters>
      <v-col md="3">
        <v-img
          v-bind:src="require('../assets/icons/' + element.icon)"
          width="23%"
          class="ml-5"
        />
        <v-container class="text-left ml-0">
          <sub class="subtitle">{{element.title}}</sub>
        </v-container>
      </v-col>
      <v-col md="9" align-self="end">
        <v-simple-table :headers="headers">
          <thead>
            <tr>
              <th v-for="item in element.items">
                <subtitle-2 class="subsection">{{item.title}}</subtitle-2>
              </th>
            </tr>
          </thead>
          <tbody>
          <tr>
            <td v-for="item in element.items">
              <body-1 class="subbody hyphens">
                {{item.body}}
              </body-1>
            </td>
          </tr>
        </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      headers: [
        {width: "25%"}
      ],
      content: [
        {
          icon: "icon-projection.png",
          title: "PROYECCIONES DEL \n SISTEMA ELÉCTRICO",
          items: [
            {
              title: "Proyecciones",
              body: "De costos marginales, generación de energía, consumo de combustibles y transmisión, utilizando nuestros modelos Modex y Modex-Hor.",
            },
            {
              title: "Modelo Modex",
              body: "Optimiza la operación del SEN en el mediano plazo con etapas mensuales y bloques horarios consecutivos, incluyendo escenarios hidrológicos y renovables. Condiciona la solución de Modex-Hor.",
            },
            {
              title: "Modelo Modex-Hor",
              body: "Optimiza la operación del SEN en una semana con etapas horarias para un escenario, incorporando elementos de la operación de corto plazo que mejoran significativamente las proyecciones.",
            },
            {
              title: "Acumulación",
              body: "Ambos modelos incluyen centrales de acumulación individuales o asociadas con una central renovable.",
            }
          ]
        },
        {
          icon: "icon-studies.png",
          title: "EVALUACIONES \n ECONÓMICAS",
          items: [
            {
              title: "Proyectos",
              body: "Evaluación de proyectos de generación.",
            },
            {
              title: "Procesos de financiación",
              body: "Consultor independiente contraparte de evaluaciones.",
            },
            {
              title: "Seguros y arbitrajes",
              body: "Evaluación de perjuicios cubiertos por seguros, y alternativas en procesos de arbitraje.",
            },
          ]
        },
        {
          icon: "icon-risk.png",
          title: "GESTIÓN DE RIESGO",
          items: [
            {
              title: "Portfolio Risk Manager",
              body: "Utilizamos nuestro modelo Portfolio Risk Manager con método de Montecarlo para evaluar el riesgo comercial de los portafolios.",
            },
            {
              title: "Evaluación de portafolios",
              body: "Evaluación del riesgo para el margen comercial de portafolios incluyendo centrales generadoras, contratos de respaldo de energía y contratos de suministro a clientes.",
            },
            {
              title: "Volumen óptimo",
              body: "Evaluación del volumen óptimo de contratación para un portafolio de centrales generadoras, o la selección de centrales necesarias para contratación de suministro.",
            },
          ]
        },
        {
          icon: "icon-math.png",
          title: "DESARROLLO \n DE MODELOS",
          items: [
            {
              title: "Sistema eléctrico",
              body: "Servicio de utilización de los modelos Modex y Modex-Hor.",
            },
            {
              title: "Modelos a medida",
              body: "Desarrollo de modelos a medida según las necesidades del cliente.",
            },
            {
              title: "Modelos desarrollados",
              body: "Operación de corto plazo de centrales hidroeléctricas en serie. Selección de propuestas en una licitación de suministro.",
            },
          ]
        },
      ],
    }
  },
}
</script>

<style>

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.subtitle {
  font-weight: 400;
  font-size: 1.5rem;
  line-height: 1.8rem;
  color: #006064;
}

.subsection {
  font-weight: 500;
  font-size: 1rem;
  color: #161c2d;
}

.subbody {
  font-size: .8rem;
  color: #161c2d;
}

.hyphens {
  hyphens: auto;
}

.v-data-table__wrapper > table > thead > tr > th {
  border: hidden !important;
}

.v-data-table__wrapper > table > tbody > tr:hover {
  background: inherit !important;
}

</style>



// WEBPACK FOOTER //
// src/components/WorkLarge.vue